import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import {
    ModalHeader,
    ModalContent,
    ModalFooter,
    ContentItem,
} from '@gnb/components/Common'
import PreferenceContentTemplate from '@gnb/templates/PreferenceContentTemplate.vue'
import RuleView from '@gnb/components/Preference/Mail/Rule/RuleView.vue'
import AddRule from '@gnb/components/Preference/Mail/Rule/AddRule.vue'
import api from '@gnb/api/common'
import { mapActions, mapGetters } from 'vuex'
import * as types from '@gnb/store/types'
import { i18n } from '@appbase/util/i18n-setup'

@Component({
    components: {
        ModalHeader,
        ModalContent,
        ModalFooter,
        ContentItem,
        PreferenceContentTemplate,
        RuleView,
        AddRule,
    },
    methods: {
        ...mapActions({
            loading: types.COMMON_LOADDING,
        }),
    },
    computed: {
        ...mapGetters({
            isLoading: types.COMMON_LOADDING,
        }),
    },
})
export default class Rule extends Vue {
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    header: string = this.$t('W_Settings_Rule').toString()
    rules: gnb.rules.Rule[] = [];    
    folders: gnb.FolderItem[] = [];   
    openRuleDetail: boolean = false
    selectedRule: gnb.rules.Rule = {
        id: '',
        name: '',
        priority: 1,
        isEnabled: true,
        operation: '',
        conditions: [],
        actions: [],
        exceptions: [],
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    loading!: (option: boolean) => void

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    isLoading!: boolean  

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    onAddRule() {
        this.selectedRule = {
            id: '',
            name: '',
            priority: 1,
            isEnabled: true,
            operation: '',
            conditions: [],
            actions: [],
            exceptions: [],
        }

        this.openRuleDetail = true
    }

    onEditRule(rule: gnb.rules.Rule) {
        this.selectedRule = rule
        this.openRuleDetail = true        
    }

    onSwapRule(from: gnb.rules.Rule, to: gnb.rules.Rule) {
        var params = [ ...this.rules ];
        var fromIdx = params.findIndex(r => r.id === from.id);
        var toIdx = params.findIndex(r => r.id === to.id);

        if(fromIdx >= 0 && toIdx >= 0) {
            from.priority = toIdx + 1;
            to.priority = fromIdx + 1;
            from.operation = 'set';
            to.operation = 'set';

            params[fromIdx] = from;
            params[toIdx] = to;

            api.setRules(params).then(() => {               
                this.refresh();
            });
        }        
    }

    onDeleteRule(item: gnb.rules.Rule) {
        var params = [ ...this.rules ];
        var idx = params.findIndex(r => r.id === item.id);

        if(idx >= 0) {
            item.operation = 'delete';
            params[idx] = item;
            api.setRules(params).then(async () => {
                await (window as any).alertAsync(this.$t('삭제_되었습니다').toString())   
                this.refresh();
            });
        }
    }

    onSaveDetail(item: gnb.rules.Rule) {
        var params = [ ...this.rules ];
        var idx = params.findIndex(r => r.id === item.id);
        
        if(idx >= 0) {
            params[idx] = item;
        } else {
            params.push(item);
        }     

        api.setRules(params).then(async () => {
            await (window as any).alertAsync(this.$t('M_Expense_SavedAlert').toString())   
            this.refresh();
        });
    }

    onEnableChange(item: gnb.rules.Rule) {
        var params = [ ...this.rules ];
        var idx = params.findIndex(r => r.id === item.id);

        if(idx >= 0) {
            item.operation = 'set';
            params[idx] = item;
            api.setRules(params).then(() => {                  
                this.refresh();
            });
        }
    }

    onCancelDetail() {
        this.openRuleDetail = false;      
    }

    convertConditions(conditions: gnb.rules.RuleCondition[]): string {   
        let text: string = '';
        var cnt: number = 0;
        conditions.forEach((c:gnb.rules.RuleCondition)=>{
            if(c.key === "ContainsSenderStrings"){  
                text += i18n.t('보낸사람이').toString() + c.value + i18n.t('_인_경우').toString();
                cnt++;
            }else if(c.key === "SentToAddresses"){
                let receiverList = c.value.map((a: any) => a.address);                                
                text += i18n.t('받는사람에').toString() + receiverList.join(', ') + i18n.t('_가_포함된_경우').toString();
                cnt++;
            }else if(c.key === "ContainsHeaderStrings"){
                text += i18n.t('헤더에').toString() + c.value + i18n.t('_가_포함된_경우').toString();
                cnt++;
            }else if(c.key === "ContainsSubjectStrings"){
                text += i18n.t('제목에').toString() + c.value + i18n.t('_가_포함된_경우').toString();
                cnt++;
            }else if(c.key === "ContainsBodyStrings"){
                text += i18n.t('내용에').toString() + c.value + i18n.t('_가_포함된_경우').toString();
                cnt++;
            }          
        });     
        
        return text;
    }

    convert(rule: gnb.rules.Rule): gnb.rules.Rule {
        const _this = this;
        let text: string = this.convertConditions(rule.conditions);
        let folderName: string = '';
        rule.actions.forEach((a:gnb.rules.RuleAction)=>{
            const getFolderName = (folders: gnb.FolderItem[]) => {
                folders.forEach((f) => {
                    if (f.id === a.value) {
                        folderName = f.displayName;
                    }
    
                    if (f.children != null) {
                        getFolderName(f.children as gnb.FolderItem[]);
                    }
                });
            }
    
            getFolderName(_this.folders);

            if(a.key === "MoveToFolder"){
                text += '"' + folderName +'"로 이동';
            }
        })

        rule.text = text;
        return rule;        
    }   

    refresh() {
        this.loading(true);
        return api.getRules().then(res => {
            this.rules = res.rules.map((rule:gnb.rules.Rule) => this.convert(rule));
            return this.rules;
        }).finally(() => {
            this.openRuleDetail = false;
            this.loading(false);
        })      
    }

    async created() {
        this.loading(true);
        this.folders = await api.getFolder();
        await this.refresh();
        this.loading(false);
    }
}
